// src/components/forms/FormList.js
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth'; // Adjust path if needed
import { useAuthenticatedApi } from '../../hooks/useAuthenticatedApi'; // Adjust path if needed
import SurveyListDraftItem from './SurveyListDraftItem'; // Adjust path if needed
import SurveyListActiveItem from './SurveyListActiveItem'; // Adjust path if needed
import SurveyListArchivedItem from './SurveyListArchivedItem'; // Adjust path if needed
import SurveyListAudienceItem from './SurveyListAudienceItem'
import SurveyListResponseItem from './SurveyListResponseItem';
import SurveyListAnalyticsItem from './SurveyListAnalyticsItem';
import SurveyListQuotasItem from './SurveyListQuotasItem'

import API_CONFIG from '../../config/api'
const BASE_URL = API_CONFIG.BASE_URL;

const SurveyComponents = {
	draft: SurveyListDraftItem,
	active: SurveyListActiveItem,
	archived: SurveyListArchivedItem,
	audience: SurveyListAudienceItem,
	response: SurveyListResponseItem,
	analytics: SurveyListAnalyticsItem,
	quotas: SurveyListQuotasItem
};

function SurveyList({ refreshTrigger, surveyStatus }) {
	// Use your custom useAuth hook to get user status (or just check if user is logged in if the hook provides that)
	const { isAuthenticated } = useAuth(); // Assuming useAuth provides isAuthenticated or user object
	const { authenticatedFetch } = useAuthenticatedApi();

	// The state will hold the list of SurveyInfo objects
	const [surveyInfoList, setSurveyInfoList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);

	const getSurveyList = async () => {
		if (!isAuthenticated) { 
			setIsLoading(false);
			return;
		}

		const surveyStatusUrl = {
			active: BASE_URL + '/surveys/active-surveys-id-list',
			quotas: BASE_URL + '/surveys/active-surveys-id-list',
			audience: BASE_URL + '/surveys/active-surveys-id-list',
			analytics: BASE_URL + '/surveys/active-surveys-id-list',
			response: BASE_URL + '/surveys/active-surveys-id-list',
			draft: BASE_URL + '/surveys/draft-surveys-id-list',
			archived: BASE_URL + '/surveys/archived-surveys-id-list'
		};


		setIsLoading(true);
		setError(null); // Clear previous errors
		try {
			// Make the API call to fetch the survey list
			// Assuming your API endpoint for fetching surveys is '/surveys'
			const result = await authenticatedFetch(surveyStatusUrl[surveyStatus], {}, "GET");
			const datas = await result.json()
			// API response is expected to be { surveys_info: [...] }
			// Update the state with the array of SurveyInfo objects
			if (datas && datas.surveys_info) {
				setSurveyInfoList(datas.surveys_info);
			} else {
				// Handle cases where the API returns an unexpected structure
				console.error("API returned unexpected structure:", result);
				setSurveyInfoList([]); // Set empty list on unexpected response
			}
		} catch (err) {
			console.error("Error fetching survey list:", err);
			setError("Failed to load surveys. Please try again.");
			setSurveyInfoList([]); // Clear list on error
		} finally {
			setIsLoading(false);
		}
	};

	// Fetch data when the component mounts or authentication status changes
	useEffect(() => {
		// Trigger fetch only if authenticated status is determined and true
		// Assuming `isAuthenticated` from useAuth hook is the correct trigger
		if (isAuthenticated) {
			 getSurveyList();
		} else if (isAuthenticated === false) {
			 // Handle not authenticated state, e.g., clear list
			 setSurveyInfoList([]);
			 setIsLoading(false);
		}
	}, [isAuthenticated]); // Dependency on isAuthenticated

	if (isLoading) {
		return <div className='mt-5 text-center text-gray-500'>Loading surveys...</div>;
	}

	if (error) {
		 return <div className='mt-5 text-center text-red-500'>{error}</div>;
	}

	if (surveyInfoList.length === 0) {
		return (
			<div className='mt-5 text-center text-gray-500'>
				<p>No surveys found.</p>
			</div>
		);
	}


	return (
		<div className='mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
			{surveyInfoList.map((surveyInfo) => {
				// Get the appropriate component based on surveyStatus
				const SurveyComponent = SurveyComponents[surveyStatus];
				
				return (
					<div key={surveyInfo.survey_id}>
						<SurveyComponent
							surveyInfo={surveyInfo}
							refreshData={getSurveyList}
						/>
					</div>
				);
			})}
		</div>
	);
}

export default SurveyList;